import BackOfficeConfig from '../Config';

const MANUAL_API_ROOT = '/api/1.0/manual';

export class ManualApiError extends Error {
  constructor(kind, status, message) {
    super(message);
    this.name = 'ManualApiError';
    this.kind = kind;
    this.status = status;
  }
}

function getAccessToken() {
  try {
    const session = JSON.parse(localStorage.getItem('apiUser') || 'null');
    return session && typeof session.accessToken === 'string'
      ? session.accessToken
      : '';
  } catch (_error) {
    return '';
  }
}

function expireSession() {
  localStorage.removeItem('apiUser');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  window.dispatchEvent(new CustomEvent('kalopsia:session-expired'));
  if (process.env.NODE_ENV !== 'test') {
    window.location.reload();
  }
}

function errorKind(status) {
  if (status === 401) return 'session-expired';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not-found';
  if (status === 503) return 'unavailable';
  return 'service-error';
}

async function requestManual(path) {
  const token = getAccessToken();
  if (!token) {
    expireSession();
    throw new ManualApiError('session-expired', 401, 'Your session has expired.');
  }

  let response;
  try {
    response = await fetch(`${BackOfficeConfig.BASE_API_URL}${MANUAL_API_ROOT}${path}`, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (_error) {
    throw new ManualApiError('unavailable', 0, 'The manual service is temporarily unavailable.');
  }

  if (response.status === 401) {
    expireSession();
  }
  if (!response.ok) {
    throw new ManualApiError(
      errorKind(response.status),
      response.status,
      'The manual request could not be completed.',
    );
  }

  try {
    return await response.json();
  } catch (_error) {
    throw new ManualApiError('invalid-content', response.status, 'The manual returned invalid content.');
  }
}

export function getManualManifest() {
  return requestManual('/manifest/');
}

export function getManualArticle(slug) {
  return requestManual(`/articles/${encodeURIComponent(slug)}/`);
}

export function searchManual(query) {
  return requestManual(`/search/?q=${encodeURIComponent(query)}`);
}
